import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'

const messages = defineMessages({
  somethingWentWrong: {
    id: 'NewsletterFormFailure.somethingWentWrong',
    defaultMessage: 'Something went wrong.'
  },
  pleaseRefresh: {
    id: 'NewsletterFormFailure.pleaseRefresh',
    defaultMessage: 'Please refresh and try again.'
  }
})

export default function NewsletterFormFailure () {
  const intl = useIntl()

  return (
    <div>
      <h3>{formatMessageIntlUtil(intl, messages.somethingWentWrong)}</h3>
      <p>{formatMessageIntlUtil(intl, messages.pleaseRefresh)}</p>
    </div>
  )
}
